import React, { useState, createContext, useContext } from 'react';
import { products as initialProducts, Product } from '../utils/data';
interface ProductContextType {
  products: Product[];
  addProduct: (product: Product) => void;
}
const ProductContext = createContext<ProductContextType | undefined>(undefined);
export const ProductProvider: React.FC<{
  children: ReactNode;
}> = ({
  children
}) => {
  const [products, setProducts] = useState<Product[]>(initialProducts);
  const addProduct = (product: Product) => {
    setProducts(prevProducts => [...prevProducts, product]);
  };
  return <ProductContext.Provider value={{
    products,
    addProduct
  }} data-id="element-81">
      {children}
    </ProductContext.Provider>;
};
export const useProducts = () => {
  const context = useContext(ProductContext);
  if (context === undefined) {
    throw new Error('useProducts must be used within a ProductProvider');
  }
  return context;
};